import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';

// import ReactDOM from 'react-dom';

import './index.scss';
import { UserManager } from 'oidc-client';
import App from './App';
import { configureServices } from './config/apiConfig';
// ----------------------------------------------------------------------

configureServices();

if (window.location.pathname === '/rcore/authentication/silent-renew') {
  new UserManager().signinSilentCallback();
} else {
  const root = createRoot(document.getElementById('root'));
  root.render(
    // <React.StrictMode>
    <App />,
    // </React.StrictMode>,
    document.getElementById('root')
  );
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
